'use client'
import React, { useEffect, useState } from 'react'
import { useLazyQuery } from '@apollo/client'
import { GET_WAGON_WHEEL_DATA } from '@/graphql/match/match.query'
import SpiderChart from './spiderChart'
import Loading from '../loading'
import NoData from '../noData'
import noDataImg from '@/assets/images/error-images/results.svg'
import PlayerListChart from './playerList'

function SpiderStats({ matchDetail, inningData }: any) {
  const { aInning, oTeamScoreA, oTeamScoreB } = matchDetail || {}
  const teamAId = aInning?.[0]?.iBattingTeamId
  const [innNumber, setInnNumber] = useState(1)
  const teamA = teamAId === oTeamScoreA?.oTeam?._id ? oTeamScoreA?.oTeam : oTeamScoreB?.oTeam
  const teamB = teamA?._id === oTeamScoreA?.oTeam?._id ? oTeamScoreB?.oTeam : oTeamScoreA?.oTeam
  const [currentTeamId, setCurrentTeamId] = useState(teamA?._id)
  const [zoneData, setZoneData] = useState<any>([])
  const [runs, setRuns] = useState<any>()
  const [playerData, setPlayerData] = useState(
    inningData?.find((i: any) => i?.iBattingTeamId === teamA?._id)
  )
  const [isData, setIsData] = useState(false)

  const labels = [
    'Fine Leg',
    'Square Leg',
    'Mid Wicket',
    'Long On',
    'Long Off',
    'Covers',
    'Point',
    'Third Man'
  ]

  function displayData(data: any) {
    const t: any = labels?.map((label: string) => {
      const l = data?.find((z: any) => z.zone === label)?.runsScored
      return l
    })
    return t
  }

  // !Query
  const [getWagonWheelData, { loading }] = useLazyQuery(GET_WAGON_WHEEL_DATA, {
    onCompleted: d => {
      const data = d?.getWagonsData || {}
      if (!runs?.total && runs?.total !== 0) {
        setIsData(!!data?.isZone)
        handleZoneData(data)
      } else {
        handleZoneData(data)
      }
    }
  })

  // !Handle Zone Data
  function handleZoneData(d: any) {
    const data = d?.zones
    const t = displayData(data)
    setZoneData(t)
    const r = { offSide: d?.runs?.offSide, onSide: d?.runs?.onSide, total: d?.runs?.total }
    setRuns(r)
  }

  // !handle Team Tab
  function handleTeam(id: string, ing: number) {
    const inningNumber = ing
    if (ing) setInnNumber(ing)
    if (inningNumber !== null) {
      getWagonWheelData({
        variables: {
          input: {
            iMatchId: matchDetail?._id,
            nInningNumber: inningNumber
          }
        }
      })
    }
    setCurrentTeamId(id)
    const t = inningData?.find((i: any) => i?.iBattingTeamId === id)
    setPlayerData(t)
  }

  useEffect(() => {
    getWagonWheelData({
      variables: {
        input: {
          iMatchId: matchDetail?._id,
          nInningNumber: 1
        }
      }
    })
  }, [])

  // !Handle Player Data
  function handlePlayersData(batter: any, bowler: any) {
    const inningNumber =
      currentTeamId === teamA?._id
        ? batter.length === 0
          ? 0
          : 1
        : currentTeamId === teamB?._id
          ? batter.length === 0
            ? 0
            : 2
          : null
    if (batter?.length === 0 || inningNumber === 0) {
      setZoneData(Array(8).fill(0))
      setRuns({ onSide: 0, offSide: 0, total: 0 })
    }
    if (inningNumber !== null && inningNumber !== 0) {
      getWagonWheelData({
        variables: {
          input: {
            iMatchId: matchDetail?._id,
            nInningNumber: inningNumber,
            iBatterIds: batter,
            iBowlerId: bowler
          }
        }
      })
    }
  }

  function handleInning(d: any) {
    handleTeam(d?.iBattingTeamId, d?.nInningNumber)
  }

  return (
    <div className="flex flex-col items-center w-full">
      {!runs?.total && runs?.total !== 0 && loading ? (
        <Loading />
      ) : isData ? (
        <>
          <div className=" md:bg-cardBg md:border border-tabBorder w-full pb-2 md:px-2 rounded-xl overflow-hiddeng my-2">
            <div
              className={`flex pt-2 pb-4 md:p-4 md:-mx-2 relative md:bg-headersActive rounded-t-xl border-b border-tabBorder gap-4 justify-center flex-nowrap whitespace-nowrap overflow-auto`}
            >
              {matchDetail?.aInning?.map((data: any, i: number) => {
                return (
                  <div
                    key={`${data?.sShortName}-${i}`}
                    className={`${
                      innNumber !== data?.nInningNumber
                        ? 'bg-theme text-textDselected cursor-pointer font-medium'
                        : 'bg-buttonBg !border-buttonBg font-bold dark:text-[#CED2D5] text-white cursor-default'
                    } text-center select-none px-4 py-1 rounded-lg w-fit border text-xs md:text-base  border-c`}
                    onClick={() => handleInning(data)}
                  >
                    {data?.sShortName}
                  </div>
                )
              })}
            </div>

            {/*RUNS MOBILE*/}
            <div className="flex md:hidden justify-center gap-4 items-center mt-4 md:bg-transparent py-4 bg-card-600 border-y rounded-lg border-card-700 w-full">
              <div className="flex items-baseline gap-2 text-start">
                <p className="text-t-note text-sm font-semibold">Off Side</p>
                <p className="text-lg">
                  {runs?.offSide}
                  <span className="mx-1 text-sm">runs</span>
                </p>
              </div>
              <div className="h-10 block w-[2px] bg-card-700"></div>
              <div className="flex items-baseline gap-2 text-start">
                <p className="text-t-note text-sm font-semibold">On Side</p>
                <p className="text-lg">
                  {runs?.onSide}
                  <span className="mx-1 text-sm">runs</span>
                </p>
              </div>
            </div>

            <div className="flex w-full justify-center md:justify-between items-center">
              <div className="text-start hidden md:flex flex-col ml-8">
                <p className="text-textDselected text-lg">Off Side</p>
                <p className="text-3xl text-textOffWhite">
                  {runs?.offSide}
                  <span className="mx-1 text-lg">runs</span>
                </p>
              </div>
              <div className="mt-4 md:h-[423px] h-[300px] relative flex justify-center">
                {zoneData && <SpiderChart labels={labels} displayData={zoneData} />}
              </div>
              <div className="text-start hidden md:flex flex-col mr-8">
                <p className="text-textDselected text-lg">On Side</p>
                <p className="text-3xl text-textOffWhite">
                  {runs?.onSide}
                  <span className="mx-1 text-lg">runs</span>
                </p>
              </div>
            </div>

            {/* <ChartFilter /> */}
          </div>

          <PlayerListChart
            matchDetail={matchDetail}
            playerData={playerData}
            currentTeamId={currentTeamId}
            handlePlayersData={handlePlayersData}
          />
        </>
      ) : (
        <NoData
          imagePath={noDataImg}
          title="Quiet innings, huh? We’ll update the scoreboard as soon as the stats show up!"
        />
      )}
    </div>
  )
}

export default SpiderStats
